
export { useDevice } from "/codebuild/output/src2912673218/src/dgbet/src/contexts/device/index.tsx"
export { useMedia } from "/codebuild/output/src2912673218/src/dgbet/src/contexts/device/index.tsx"